import { buildSkillStep } from "@/core/skillForms/builder";

const legalAdviceMaxLength = 3000;

export const legalAdviceSkillStep2 = buildSkillStep({
  title: "Detalhes do caso",
  description: "Insira um detalhamento sobre o caso com o maior número de informações possíveis. ",
  fields: [
    {
      name: "case_breakdown",
      type: "string",
      maxLength: legalAdviceMaxLength,
      ui: {
        label: "Faça um detalhamento do caso:",
        placeholder:
          "Exemplo: A Fazenda Santa Clara Ltda. precisa instituir uma servidão de passagem para acessar uma estrada pública. Solicita um parecer jurídico sobre a viabilidade, procedimentos, obstáculos e estratégias para obter a autorização necessária.",
        widget: "textarea",
      },
    },
  ],
  submitButtonText: "Elaborar parecer jurídico",
});
